function Button({
  children,
  onClickMethod = () => {console.log('no method')},
  className = '',
  color = 'yellow', width = 'auto', mobileWidth = 'auto',
  type='button',
  disabled = false
}) {
  const colorClass = {
    yellow: 'bg-yellow-viv',
    black: 'bg-black text-white',
    black_bordered: 'border border-black text-black',
    red: 'bg-red-200 text-red-500',
    red_bordered: 'border border-red-500 text-red-500',
    gray: 'bg-gray-200 text-gray-700',
    green: 'bg-green-500',
    blue: 'bg-blue-500',
    transparent: 'bg-transparent',
  }[color] || colorClass.yellow;

  const widthClass = {
    auto: 'sm:w-auto',
    full: 'sm:w-full',
    '11/12': 'sm:w-11/12',
    '10/12': 'sm:w-10/12',
    '9/12': 'sm:w-9/12',
    '8/12': 'sm:w-8/12',
    '7/12': 'sm:w-7/12',
    '6/12': 'sm:w-6/12',
    '5/12': 'sm:w-5/12',
    '4/12': 'sm:w-4/12',
    '3/12': 'sm:w-3/12',
    '2/12': 'sm:w-2/12',
    '1/12': 'sm:w-1/12',
  }[width] || widthClass.auto;

  const mobileWidthClass = {
    auto: 'w-auto',
    full: 'w-full',
    '11/12': 'w-11/12',
    '10/12': 'w-10/12',
    '9/12': 'w-9/12',
    '8/12': 'w-8/12',
    '7/12': 'w-7/12',
    '6/12': 'w-6/12',
    '5/12': 'w-5/12',
    '4/12': 'w-4/12',
    '3/12': 'w-3/12',
    '2/12': 'w-2/12',
    '1/12': 'w-1/12',
  }[mobileWidth] || mobileWidthClass.auto;

  return (
    <button
      className={`flex justify-center items-center min-w-max text-black px-4 py-2 rounded-md ${colorClass} ${mobileWidthClass} ${widthClass}`}
      disabled={disabled}
      type={type}
      onClick={(e) => onClickMethod(e)}
    >
      {children}
    </button>
  );
}

export default Button;
